import { render, staticRenderFns } from "./RecordCard.vue?vue&type=template&id=085b4c30&scoped=true&"
import script from "./RecordCard.vue?vue&type=script&lang=ts&"
export * from "./RecordCard.vue?vue&type=script&lang=ts&"
import style0 from "./RecordCard.vue?vue&type=style&index=0&id=085b4c30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085b4c30",
  null
  
)

export default component.exports